export const enNavbar={
     "about_us": "About Us",
        "our_services": "Our Services",
        "our_projects": "Our Projects",
        "our_team": "Our Team",
        "our_solutions": "Our Solutions",
        "our_values": "Our Values",
        "our_references": "Our References",
        "hosting": "Hosting",
        "contact": "Contact Us",
        "language": {
        "english": "English",
        "french": "French",
        "flemish": "Flemish",
        "german": "German"
      },
}
export const frNavbar={
    "about_us": "À Propos",
    "our_services": "Nos Services",
    "our_projects": "Nos Projets",
    "our_team": "Notre Équipe",
    "our_solutions": "Nos Solutions",
    "our_values": "Nos Valeurs",
    "our_references": "Nos Références",
    "hosting": "Hébergement",
    "contact": "Contactez Nous",
    "language": {
        "english": "Anglais",
        "french": "Français",
        "flemish": "Flamand",
        "german": "Allemand"
      },
}

export const nlNavbar={
    "about_us": "Over Ons",
    "our_services": "Onze Diensten",
    "our_projects": "Onze Projecten",
    "our_team": "Ons Team",
    "our_solutions": "Onze Oplossingen",
    "our_values": "Onze Waarden",
    "our_references": "Onze Referenties",
    "hosting": "Hosting",
    "contact": "Neem Contact Op",
    "language": {
        "english": "Engels",
        "french": "Frans",
        "flemish": "Vlaams",
        "german": "Duits"
      },
}

export const deNavbar = {
    "about_us": "Über Uns",
    "our_services": "Unsere Dienstleistungen",
    "our_projects": "Unsere Projekte",
    "our_team": "Unser Team",
    "our_solutions": "Unsere Lösungen",
    "our_values": "Unsere Werte",
    "our_references": "Unsere Referenzen",
    "hosting": "Hosting",
    "contact": "Kontaktieren Sie Uns",
    "language": {
        "english": "Englisch",
        "french": "Französisch",
        "flemish": "Flämisch",
        "german": "Deutsch"
      },
}